import { lazy as lazyLoad } from 'react';

import { route } from '../job-list/constants';

import type { RouteDefinition } from '../../route';

const lazy = {
    JobPage: lazyLoad(async () => {
        const { JobPage } = await import('./JobDetails');

        return { default: JobPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.jobs.title',
        page: lazy.JobPage,
        path: route.patterns.job.details,
    },
];
